angular.module("Main").controller("ShopSuccessController", ["$rootScope", "$scope", "$state", "$window", "$stateParams", "$localStorage", "$location", "$translate", "$uibModal", "PaymentService", "BookingService", "SessionService", "ShopService",
    function ($rootScope, $scope, $state, $window, $stateParams, $localStorage, $location, $translate, $uibModal, PaymentService, BookingService, SessionService, ShopService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'shopData');
            //unregisterEventHandler();
            $state.go('shop', {cid: $stateParams.cid, id: $stateParams.id});
        });

        vm.bookingLost = false;
        vm.cashBack = false;
        vm.cookies = SessionService.checkSession();
        vm.currentUser = $localStorage.user;

        getKursbuchungLayouKonfiguration();
        getOnlineShopConfiguration()


        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function getOnlineShopConfiguration() {
            ShopService.getOnlineShopConfiguration().then(function (data) {
                vm.onlineShopConfig = data;
            });
        }

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        vm.isPayment = false;
        vm.isPayPal = false;

        if (!SessionService.getSessionId()) {
            $state.go("shop", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();


        function init() {
            vm.hasError = false;
            vm.Bild = $stateParams.qr;
            ShopService.checkStatus($stateParams.oid).then(function (status) {
                vm.status = status;
                vm.shopData = {
                    OrderNr: $stateParams.oid,
                    Name: vm.status.Bezeichnung,
                    Preis: vm.status.Preis,
                    PersonNr: vm.status.PersonNr,
                    RechnungsNr: vm.status.RechnungsNr,
                    BookingNr: vm.status.BookingNr,
                    Status: vm.status.Status,
                    Confirmed: vm.status.Confirmed
                };
                vm.zahlmethode = vm.status.Zahlmethode;
            }).then(function () {
                getMemberData()
                vm.remindLocalePayment = $stateParams.locale;
            })
        }

        function getMemberData() {
            vm.personNr = vm.shopData.PersonNr;
            let userData = $localStorage.user;
        BookingService.getUserDetails(userData.uid).then(function (data) {
            vm.memberNr = vm.personNr;
            vm.isMember = $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
            vm.isLoggedIn = !_.isNil(userData) && !_.isUndefined($localStorage.user.username);
            vm.member = $localStorage.user;
            vm.member.firstname = $localStorage.user.Firstname;
            vm.member.lastname = $localStorage.user.Lastname;
            vm.member.email = $localStorage.user.Email;
            if (!_.isNil(data)) {
                vm.isLoggedIn = true;
                vm.username = data.firstname + " " + data.lastname;
                vm.hideLogin = true;
                $rootScope.$emit("login");
            }
        })
        }

    }])